export default "__VITE_ASSET__WgXMxNAO__"